import { ReactMarkdown } from "react-markdown/lib/react-markdown";

const Markdown = (markdown) => {
    return <ReactMarkdown>{markdown}</ReactMarkdown>;
  };
  export default Markdown;